// Make jQuery globally available.
import * as $ from 'jquery';

window.$ = window.jQuery = $;
